<!-- eslint-disable vue/valid-v-model -->
<template>
  <v-card flat class="px-6">
    <v-row no-gutters>
      <v-col cols="12">
        <a type="primary" size="xsmall" @click="beforeLeave">
          <v-icon size="12" class="backIcon">mdi-arrow-left</v-icon>
          {{ $t('message.actions.return') }}
        </a>
      </v-col>
    </v-row>

    <div class="grid__control">
      <div class="mb-4">
        <div class="body-bold-medium">
          {{ $t('message.quiz.title') }}
        </div>
        <div
          class="body-regular-smaller neutral-40-light--text pt-2 pb-3 d-flex align-center"
        >
          {{ $t('message.quiz.describeTitle') }}
          <a target="_blank" type="secondary" class="ml-1" :href="leadArticle">
            <span>
              {{ $t('message.embedModal.knowMore') }}
            </span>
            <v-icon size="12">mdi-open-in-new</v-icon>
          </a>
        </div>
      </div>

      <v-tabs
        v-model="activeTab"
        class="playr-tabs"
        align-tabs="start"
        fixed-tabs
      >
        <v-tab>{{ $t('message.quiz.general') }}</v-tab>
        <v-tab>{{ $t('message.quiz.questions') }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card flat width="100%" class="mt-4">
            <GeneralConfigs
              :background="generalData.background"
              :questions="generalData.questions"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat width="100%" class="mt-4">
            <Questions
              :questions="questions"
              @validation-change="handleQuestionsValidation"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <!-- Portal para ações de salvamento -->
    <portal to="actions-footer">
      <div class="d-flex flex-row actions-row">
        <v-spacer></v-spacer>
        <v-tooltip max-width="184px" top :disabled="canCancel">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="tertiary"
                class="mr-2 px-4"
                text
                :disabled="!canCancel"
                @click="handleUndoChanges"
              >
                {{ $t('message.actions.cancel') }}
              </base-btn>
            </div>
          </template>
          <span>{{ $t('message.noChanges') }}</span>
        </v-tooltip>
        <v-tooltip max-width="184px" top :disabled="canPublish">
          <template v-slot:activator="{ on, attrs }">
            <div class="pl-2" v-bind="attrs" v-on="on">
              <base-btn
                type="primary"
                :loading="loading"
                :disabled="!canPublish"
                width="150"
                @click="handleSave"
              >
                <span class="px-5">{{ $t('message.actions.publish') }}</span>
              </base-btn>
            </div>
          </template>
          <span>{{
            !hasValidUrls
              ? $t('message.invalidUrl')
              : !isExistentCta && !canPublish
              ? $t('message.errors.emptyFields')
              : withoutChanges && isExistentCta
              ? $t('message.noChanges')
              : $t('message.errors.emptyFields')
          }}</span>
        </v-tooltip>
      </div>
    </portal>
    <add-video-destiny-interactions :funnelFolderId="currentVideoFolderId" />
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import GeneralConfigs from './GeneralConfigs.vue'
import Questions from './Questions.vue'
import AddVideoDestinyInteractions from '../AddVideoDestinyInteractions.vue'
import playerApi from '@/services/playerApi'
//import SaveChangesFooter from '../SaveChangesFooter.vue'
import { isEmpty } from '@aws-amplify/core'
import _ from 'lodash'
import ctaRedirectMixin from '@/mixins/ctaRedirectMixin'
import videosApi from '@/services/videosApi'

export default {
  name: 'VideoPlayerQuizCta',
  components: {
    GeneralConfigs,
    Questions,
    AddVideoDestinyInteractions,
    //SaveChangesFooter,
  },
  mixins: [ctaRedirectMixin],
  data() {
    return {
      isTimelineDragging: false,
      loading: false,
      isExistentCta: false,
      initialQuestions: [],
      initialGeneralData: {},
      generalDataDefault: {
        questions: {
          styleText: '',
          layout: 0,
          horizontalLayout: 0,
          verticalLayout: 0,
          alternativesSelectedBackgroundColor: { background: '#000000' },
          selectedExitAnimation: '',
          selectedEnterAnimation: '',
          pauseVideo: true,
          pauseVideoEnd: false,
          hasTimeBar: true,
          selectedButtonModel: '',
          selectedColor: '',
          allowSkip: true,
          skipButtonText: this.$t('message.pages.onboardingModal.skip'),
          fontSize: 16,
          fontColor: {
            color: '#FFFFFF',
          },
          questionTextColor: {
            color: '#FFFFFF',
          },
          fontWeight: 'normal',
          availableFontWeights: [
            { name: 'Normal', value: 'normal' },
            { name: 'Bold', value: 'bold' },
            { name: 'Bolder', value: 'bolder' },
            { name: 'Lighter', value: 'lighter' },
          ],
        },
        background: {
          color: {
            color: '#000000',
            opacity: 100,
            alternativesOpacity: 100,
          },
        },
        startTime: '00:00',
        endTime: '00:00',
        duration: 0,
        id: null,
      },
      generalData: {},
      questions: [],
      activeTab: null,
      isInitializing: false,
      isQuestionsValid: false,
    }
  },
  methods: {
    ...mapMutations('dashboard', ['UPDATE_VIDEO_TIMELINE_ITEMS']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapMutations('video', [
      'UPDATE_LOADING_SAVE',
      'UPDATE_VIDEO_CONFIG_CTAS',
    ]),
    beforeLeave() {
      this.$router.push({
        name: 'VideoPage',
        params: { id: this.$route.params.id },
      })
    },
    handleUndoChanges() {
      this.generalData = _.cloneDeep(this.initialGeneralData)
      this.questions = _.cloneDeep(this.initialQuestions)
      this.handleSnackbar(this.$t('message.actions.discardChanges'))
    },
    loadInitialData() {
      this.isInitializing = true

      this.generalData = _.cloneDeep(this.generalDataDefault)
      const videoConfigQuizItem =
        this.video?.config?.ctas &&
        this.video.config?.ctas.find(
          (cta) => cta.id === this.$route.params.quizId
        )
      this.isExistentCta = !!videoConfigQuizItem

      const timelineQuizItem = _.cloneDeep(
        this.timelineItems.find(
          (item) => item?.data?.id === this.$route.params.quizId
        )
      )

      this.generalData.id =
        timelineQuizItem?.data?.id || this.$route.params.quizId

      if (!_.isEmpty(timelineQuizItem)) {
        this.questions = timelineQuizItem.data.metadata.questions
          ? _.cloneDeep(timelineQuizItem.data.metadata.questions)
          : []
        this.generalData = {
          ...this.generalData,
          ..._.cloneDeep(timelineQuizItem.data.metadata.generalData),
        }

        this.generalData.startTime = timelineQuizItem.data.metadata.startTime
        this.generalData.endTime = timelineQuizItem.data.metadata.endTime
        this.generalData.duration = timelineQuizItem.data.duration
      }

      if (videoConfigQuizItem) {
        this.initialGeneralData = _.cloneDeep(
          videoConfigQuizItem.metadata.generalData
        )
        this.initialQuestions = _.cloneDeep(
          videoConfigQuizItem.metadata.questions
        )
      } else {
        this.initialGeneralData = _.cloneDeep(this.generalData)
        this.initialQuestions = _.cloneDeep(this.questions)
      }

      this.loadCtaData()

      this.$nextTick(() => {
        this.isInitializing = false
        // Validate questions immediately after initialization
        if (this.questions.length > 0) {
          this.isQuestionsValid = this.validateAllQuestions()
        }
      })
    },
    validateAllQuestions() {
      // Validate each question
      return this.questions.every((question) => {
        const isStatementValid =
          question.statement.value && question.statement.value.length <= 120

        const areAnswersValid = question.answers.every((answer) => {
          const isTextValid = answer.text && answer.text.length <= 30

          let isActionValid = true
          if (answer.action === 'redirect_video') {
            isActionValid = !!answer.redirectVideoId
          } else if (answer.action === 'redirect_question') {
            isActionValid =
              answer.nextQuestion !== undefined && answer.nextQuestion !== null
          } else if (answer.action === 'open_link') {
            const urlPattern =
              /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/
            isActionValid =
              !!answer.link &&
              answer.link.trim() !== '' &&
              urlPattern.test(answer.link)
          }

          return isTextValid && isActionValid
        })

        return isStatementValid && areAnswersValid
      })
    },
    hexToRgba(hex, opacity) {
      const hexColor = hex.replace('#', '')
      const r = parseInt(hexColor.substring(0, 2), 16)
      const g = parseInt(hexColor.substring(2, 4), 16)
      const b = parseInt(hexColor.substring(4, 6), 16)
      return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`
    },
    lightenColor(color, percent) {
      const num = parseInt(color.slice(1), 16)
      const amt = Math.round(2.55 * percent)
      const R = (num >> 16) + amt
      const G = ((num >> 8) & 0x00ff) + amt
      const B = (num & 0x0000ff) + amt

      const newColor =
        '#' +
        (
          0x1000000 +
          (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
          (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
          (B < 255 ? (B < 1 ? 0 : B) : 255)
        )
          .toString(16)
          .slice(1)
          .toUpperCase()

      return newColor
    },
    updateSaveArray() {
      const ctaData = this.generateCtaData()
      console.log('ctaData', ctaData)
      // const index = this.$globalSettings.saveArray.findIndex(
      //   (el) => el.ctaId === ctaData.id
      // )
      // if (index !== -1) {
      //   this.$globalSettings.saveArray[index].ctaData = ctaData
      // } else {
      //   this.$globalSettings.saveArray.push({
      //     ctaData: ctaData,
      //     ctaId: ctaData.id,
      //   })
      // }
    },
    generateCtaData() {
      const videosRedirect = this.questions
        .filter((question) =>
          question.answers.some((answer) => answer.action === 'redirect_video')
        )
        .map((question) =>
          question.answers.map((answer) => answer.redirectVideoId)
        )
        .flat()

      const videoRedirectExternalIds = this.questions
        .filter((question) =>
          question.answers.some((answer) => answer.action === 'redirect_video')
        )
        .map((question) =>
          question.answers.map((answer) => answer.redirectVideoExternalId)
        )
        .flat()

      // If start time is 00:00, treat it as 00:01 internally for player registration
      const effectiveStartTime =
        this.elementTimes.startTime === 0 ? 1 : this.elementTimes.startTime

      const ctaData = {
        script: this.generateScriptFromQuestions(),
        type: 'video',
        time: effectiveStartTime,
        duration: this.elementTimes.duration,
        metadata: {
          generalData: this.generalData,
          disposition: this.generalData.questions.layout,
          questionDisposition: this.generalData.questions.horizontalLayout,
          verticalLayout: this.generalData.questions.verticalLayout,
          questions: this.questions,
          ctaType: 'quiz',
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
          redirects: videosRedirect,
          videoRedirectExternalIds,
        },
        maxZIndex: true,
        pauseVideo: this.generalData.questions.pauseVideo,
        pauseVideoEnd: this.generalData.questions.pauseVideoEnd,
        barColor: this.generalData.questions.fontColor.color,
        hasTimeBar: this.generalData.questions.hasTimeBar,
        alternativesSelectedBackgroundColor:
          this.generalData.questions.alternativesSelectedBackgroundColor,
        allowSkip: this.generalData.questions.allowSkip,
        selectedButtonModel: this.generalData.questions.selectedButtonModel,
        buttonColor: this.generalData.questions.selectedColor,
        id: this.generalData.id,
      }

      return ctaData
    },
    formatLinkToOpen(url) {
      if (!url) return ''
      if (url.includes('http://') || url.includes('https://')) {
        return url
      }
      return `https://${url}`
    },
    updatePlayerCtas() {
      const videosRedirect = this.questions
        .filter((question) =>
          question.answers.some((answer) => answer.action === 'redirect_video')
        )
        .map((question) =>
          question.answers.map((answer) => answer.redirectVideoId)
        )
        .flat()
      const newTimelineItems = this.timelineItems.map((item) => {
        if (isEmpty(item)) return item
        if (item.data.id === this.generalData.id) {
          // If start time is 00:00, treat it as 00:01 internally for player registration
          const effectiveStartTime =
            this.elementTimes.startTime === 0 ? 1 : this.elementTimes.startTime

          item.data = {
            script: this.generatedScript,
            type: 'video',
            time: effectiveStartTime,
            duration: this.elementTimes.duration,
            metadata: {
              generalData: this.generalData,
              questions: this.questions,
              disposition: this.generalData.questions.layout,
              questionDisposition: this.generalData.questions.horizontalLayout,
              layout: this.generalData.questions.layout,
              verticalLayout: this.generalData.questions.verticalLayout,
              ctaType: 'quiz',
              startTime: this.elementTimes.startTimeStr,
              endTime: this.elementTimes.endTimeStr,
              redirects: videosRedirect,
            },
            maxZIndex: true,
            pauseVideo: this.generalData.questions.pauseVideo,
            pauseVideoEnd: this.generalData.questions.pauseVideoEnd,
            barColor: this.generalData.questions.fontColor.color,
            hasTimeBar: this.generalData.questions.hasTimeBar,
            alternativesSelectedBackgroundColor:
              this.generalData.questions.alternativesSelectedBackgroundColor,
            allowSkip: this.generalData.questions.allowSkip,
            selectedButtonModel: this.generalData.questions.selectedButtonModel,
            buttonColor: this.generalData.questions.selectedColor,
            id: this.generalData.id,
          }
        }
        return item
      })
      this.UPDATE_VIDEO_TIMELINE_ITEMS([...newTimelineItems])
      this.$root.$emit('reloadPlayerCtas')
    },
    loadCtaData() {
      const ctaData = this.generateCtaData()
      console.log('ctaData', ctaData)
      // if (
      //   !this.$globalSettings.saveArray.some(
      //     (el) => el.ctaData.id === ctaData.id
      //   )
      // ) {
      //   this.$globalSettings.saveArray.push({
      //     ctaData: ctaData,
      //     ctaId: ctaData.metadata.generalData.id,
      //   })
      // }
    },
    async handleSave() {
      this.loading = true
      const videosRedirect = this.questions
        .filter((question) =>
          question.answers.some((answer) => answer.action === 'redirect_video')
        )
        .map((question) =>
          question.answers.map((answer) => answer.redirectVideoId)
        )
        .flat()

      const videoRedirectExternalIds = this.questions
        .filter((question) =>
          question.answers.some((answer) => answer.action === 'redirect_video')
        )
        .map((question) =>
          question.answers.map((answer) => answer.redirectVideoExternalId)
        )
        .flat()

      const effectiveStartTime =
        this.elementTimes.startTime === 0 ? 1 : this.elementTimes.startTime

      const ctaData = {
        script: this.generateScriptFromQuestions(),
        type: 'video',
        time: effectiveStartTime,
        duration: this.elementTimes.duration,
        metadata: {
          generalData: this.generalData,
          disposition: this.generalData.questions.layout,
          questionDisposition: this.generalData.questions.horizontalLayout,
          verticalLayout: this.generalData.questions.verticalLayout,
          questions: this.questions,
          ctaType: 'quiz',
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
          redirects: videosRedirect,
          videoRedirectExternalIds,
        },
        maxZIndex: true,
        pauseVideo: this.generalData.questions.pauseVideo,
        pauseVideoEnd: this.generalData.questions.pauseVideoEnd,
        barColor: this.generalData.questions.fontColor.color,
        hasTimeBar: this.generalData.questions.hasTimeBar,
        alternativesSelectedBackgroundColor:
          this.generalData.questions.alternativesSelectedBackgroundColor,
        selectedButtonModel: this.generalData.questions.selectedButtonModel,
        buttonColor: this.generalData.questions.selectedColor,
        allowSkip: this.generalData.questions.allowSkip,
        id: this.generalData.id,
      }

      // Use canPublish para a validação, que já considera novos CTAs
      if (!this.canPublish) {
        this.handleErrorSnackbar(this.$t('message.emptyFields'))
        this.loading = false
      } else {
        try {
          const { data } = await playerApi.addCta(this.video.id, ctaData)
          this.UPDATE_VIDEO_CONFIG_CTAS(data.ctas)
          this.isExistentCta = true
          this.handleSnackbar(this.$t('message.changesSaved'))

          const timelineInfoBarItem = this.timelineItems.find(
            (item) => item.data.id === this.generalData.id
          )
          timelineInfoBarItem.isDraft = false
          this.initialGeneralData = _.cloneDeep(this.generalData)
          this.initialQuestions = _.cloneDeep(this.questions)
          // Garantir que o footer permaneça visível após o salvamento
          this.$emit('showFooter', true)
          this.loading = false
        } catch (error) {
          console.error('Error saving quiz:', error)
          this.handleErrorSnackbar(
            error?.response?.data?.errMsg ||
              error?.response?.data?.message ||
              this.$t('message.errors.unexpectedError')
          )
          this.loading = false
        }
      }
    },
    async handleDelete() {
      this.loading = true
      this.$root.$emit('updateTimelineLoading', true)
      try {
        await playerApi.deleteCta(this.video.id, this.generalData.id)
        this.$root.$emit('updateTimelineLoading', false)
        this.handleSnackbar(
          this.$t('message.ai.quiz.removeModal.removeQuestionSnackbar')
        )
        this.loading = false
      } catch (error) {
        console.error('Error deleting quiz:', error)
        this.$root.$emit('updateTimelineLoading', false)
        this.handleErrorSnackbar(
          error?.response?.data?.errMsg ||
            error?.response?.data?.message ||
            this.$t('message.errors.unexpectedError')
        )
        this.loading = false
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = this.$t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleErrorSnackbar(errorMsg) {
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: errorMsg || this.$t('message.errors.unexpectedError'),
        type: 'error',
      })
    },
    generateScriptFromQuestions() {
      if (this.questions.length === 0) {
        this.questions.push({
          statement: {
            value: this.$i18next.t('message.quiz.questionOne'),
          },
          answers: [
            {
              text: this.$i18next.t('message.quiz.answerA'),
              action: 'redirect_video',
            },
            {
              text: this.$i18next.t('message.quiz.answerB'),
              action: 'redirect_video',
            },
          ],
          index: 0,
        })
      }
      const quizQuestions = this.questions.map((question) => {
        const answersFormatted = question.answers.map((answer) => {
          return {
            text: answer.text,
            action: {
              type: answer.action,
              nextQuestion: answer.nextQuestion,
              link:
                answer.action === 'open_link'
                  ? this.formatLinkToOpen(answer.link)
                  : undefined,
              videoExternalId:
                answer.action === 'redirect_video'
                  ? answer.redirectVideoExternalId
                  : undefined,
            },
          }
        })
        return {
          question: question.statement.value,
          answers: answersFormatted,
        }
      })
      const pauseVideoEnd = this.generalData.questions.pauseVideoEnd
      const selectedExitAnimation =
        this.generalData.questions.selectedExitAnimation

      const quizScript =
        `
                    <style>
      @import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500;600;700&display=swap');
      body {
        font-family: 'Rubik', sans-serif;
      }

      h2, .questionText, .answers button, .answers a {
        font-family: 'Rubik', sans-serif;
      }
html {
overflow: hidden;
}

@keyframes slideInProgress {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    ${
      this.generalData.questions.selectedEnterAnimation === 'horizontal_entry'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateX(100%);'
          : 'transform: translateX(-100%);'
        : this.generalData.questions.selectedEnterAnimation === 'vertical_entry'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateY(-100%);'
          : 'transform: translateY(100%);'
        : ''
    };
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes topSlideIn {
  from {
    ${
      this.generalData.questions.selectedEnterAnimation === 'horizontal_entry'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateX(100%);'
          : 'transform: translateX(-100%);'
        : this.generalData.questions.selectedEnterAnimation === 'vertical_entry'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateY(100%);'
          : 'transform: translateY(-100%);'
        : ''
    };
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    ${
      this.generalData.questions.selectedExitAnimation === 'horizontal_exit'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateX(100%);'
          : 'transform: translateX(-100%);'
        : this.generalData.questions.selectedExitAnimation === 'vertical_exit'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateY(100%);'
          : 'transform: translateY(-100%);'
        : ''
    };
    opacity: 0;
  }
}

@keyframes bottomSlideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    ${
      this.generalData.questions.selectedExitAnimation === 'horizontal_exit'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateX(100%);'
          : 'transform: translateX(-100%);'
        : this.generalData.questions.selectedExitAnimation === 'vertical_exit'
        ? this.generalData.questions.verticalLayout === 1
          ? 'transform: translateY(-100%);'
          : 'transform: translateY(100%);'
        : ''
    };
    opacity: 0;
  }
}
@keyframes slideInButtons {
  0% {
${
  this.generalData.questions.selectedEnterAnimation === 'horizontal_entry'
    ? this.generalData.questions.verticalLayout === 1
      ? 'transform: translateX(70px);'
      : 'transform: translateX(-70px);'
    : this.generalData.questions.selectedEnterAnimation === 'vertical_entry'
    ? this.generalData.questions.verticalLayout === 1
      ? 'transform: translateY(70px);'
      : 'transform: translateY(70px);'
    : ''
};
    opacity: 0;
  }
  80% {
      ${
        this.generalData.questions.selectedEnterAnimation === 'horizontal_entry'
          ? this.generalData.questions.verticalLayout === 1
            ? 'transform: translateX(-5px);'
            : 'transform: translateX(5px);'
          : this.generalData.questions.selectedEnterAnimation ===
            'vertical_entry'
          ? this.generalData.questions.verticalLayout === 1
            ? 'transform: translateY(-5px);'
            : 'transform: translateY(5px);'
          : ''
      };
    opacity: 1;
  }
  100% {
    transform: translateX(0px);
    opacity: 1;
  }
}

.slide-in {
  animation: slideIn 0.5s ease-out forwards;
}

.top-slide-in {
  animation: topSlideIn 0.5s ease-out forwards;
}

.progress-slide-in {
  animation: slideInProgress 0.5s ease-out forwards;
}

.button-slide-in {
  animation: slideInProgress 0.5s ease-out forwards;
}

.slide-out {
  animation: slideOut 0.5s ease-in forwards;
}

.bottom-slide-out {
  animation: bottomSlideOut 0.5s ease-in forwards;
}

#video-container{
width: 100%;
height: 100%;
  ${
    this.generalData.questions.layout === 0
      ? 'display: grid; grid-template-rows: auto 1fr; position: relative;'
      : ''
  };
    ${
      this.generalData.questions.layout === 1
        ? 'display: grid; position: relative;'
        : ''
    };

}
                      #container{
                        padding: 12px 0;
                        display: flex;
                        background-color: ${this.hexToRgba(
                          this.generalData.background.color.color,
                          this.generalData.background.color.opacity
                        )};
                        font-family: 'Rubik', sans-serif;
                        width: 100%;
                        ${
                          this.generalData.questions.horizontalLayout === 0
                            ? 'position: absolute; '
                            : ''
                        };
                          ${
                            this.generalData.questions.horizontalLayout === 1
                              ? 'position: absolute; bottom: 85px;'
                              : ''
                          };
                            ${
                              this.generalData.questions.layout === 1
                                ? 'width: 100%; height: auto; min-height: 100px;'
                                : ''
                            };

                      }
                        #container2{
                          padding-top: 5px;
                          ${
                            this.generalData.questions.layout === 1
                              ? 'width: 100%; height: 100%; display: flex;'
                              : 'width: 100%; position: absolute; bottom: 0; display: flex;'
                          };
                           ${
                             this.generalData.questions.verticalLayout === 1
                               ? 'right: 0;'
                               : 'left: 0'
                           };
                        background-color: ${this.hexToRgba(
                          this.generalData?.questions
                            ?.alternativesSelectedBackgroundColor?.background ||
                            '#000000',
                          this.generalData.background.color
                            .alternativesOpacity || 100
                        )};
                        font-family: 'Rubik', sans-serif;
                      }
                        #container2 button {
                        animation: slideInButtons 1s ease-out forwards;
  opacity: 0;
}
  #container2 button:nth-child(1) {
  animation-delay: 0.6s;
}

#container2 button:nth-child(2) {
  animation-delay: 1s;
}

#container2 button:nth-child(3) {
  animation-delay: 1.4s;
}

.side-section {
    ${
      this.generalData.questions.layout === 1
        ? 'display: grid; grid-template-rows: auto 6.5px 1fr; width: 35%; height: 100%; background-color: transparent; position: absolute; top: 0;'
        : ''
    };
     ${
       this.generalData.questions.verticalLayout === 0
         ? 'left: 0;'
         : 'right: 0;'
     };
}

.progress-container {
  height: 5px;
    ${
      this.generalData.questions.hasTimeBar
        ? 'background-color: #1A181A;'
        : `background-color:${this.hexToRgba(
            this.generalData.background.color.color,
            this.generalData.background.color.opacity
          )}`
    };
  border-radius: 100px;
  z-index: 10;
  overflow: hidden;
  opacity: 1;
  transition: visibility 0s linear 2s, opacity 0s linear 2s;
  ${
    this.generalData.questions.layout === 0
      ? 'position: absolute;  width: 100%; bottom: 80px'
      : ''
  };
  ${this.generalData.questions.layout === 1 ? 'width: 85%;' : ''};
  ${this.generalData.questions.verticalLayout === 1 ? 'right: 0;' : ''};
}
  @keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

  .progress-bar {
    height: 100%;
    border-radius: 100px;
    transition: transform 0.5s ease-in-out;
    transform: scaleX(0);
    will-change:  transform;
    ${
      this.generalData.questions.hasTimeBar
        ? `background: linear-gradient(90deg, ${
            this.generalData.questions.fontColor.color
          }, ${this.lightenColor(
            this.generalData.questions.fontColor.color,
            30
          )});`
        : 'background: transparent;'
    }
  }
  }

                      h2{
                        color: ${this.generalData.questions.fontColor.color};
                        font-size: 1.5rem;
                        font-weight: 500;
                      }
                      .question{
                        margin: auto !important;
                        display: flex !important;
                        flex-direction: column !important;
                        max-width: 500px !important;
                        position: static !important;
                        bottom: unset !important; 
                        left: unset !important;
                        transform: none !important; 
                        ${this.generalData.questions.styleText}
                      }
                      .answers{
                        display: ${
                          this.generalData.questions.layout === 1
                            ? 'flex; flex-direction: column;'
                            : 'flex; gap: 24px;'
                        };
                        margin: 20px 0;
                        gap: 20px;

                      }
                      .answer-button{
                        font-size: 1.2rem;
                        color: ${this.generalData.questions.fontColor.color};
                        background-color: transparent;
                        border-radius: 10px;
                        padding: 12px 15px;
                        border: 1px solid ${
                          this.generalData.questions.fontColor.color
                        };
                        margin-top: 10px;
                        cursor: pointer;
                      }
.default {
  border: none;
  padding: 10px var(--Box-Margem-vertical, 24px);
  min-height: 40px;
  justify-content: center;
  background-color: ${
    this.generalData.questions?.selectedColor?.fill || '#5F2EEA'
  };
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 4px;
  ${
    this.generalData.questions.selectedColor?.fill === '#FFF7AE'
      ? 'color: #363940;'
      : this.generalData.questions.selectedColor?.fill === '#A4BDFF'
      ? 'color: #1B0570;'
      : 'color: #fff;'
  }
  cursor: pointer;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.default:hover {
background-color: ${
          this.generalData.questions?.selectedColor?.path || '#774DED'
        };
    }

    .losangle {
    width: 100% !important;
    cursor: pointer !important;
    background-color: transparent;
    border: none;
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    ${
      (this.generalData.questions?.alternativesSelectedBackgroundColor
        ?.background || '#000000') === '#000000'
        ? 'color: #FFFFFF;'
        : 'color: #363940;'
    }
    }

.losangle:hover {
  ${
    (this.generalData.questions?.alternativesSelectedBackgroundColor
      ?.background || '#000000') === '#000000'
      ? 'color: #FFFFFF;'
      : 'color: #363940;'
  }
}

.dimension {
  border: none;
  background-color: ${
    this.generalData.questions?.selectedColor?.fill || '#5F2EEA'
  };
  padding: 10px var(--Box-Margem-vertical, 24px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  ${
    this.generalData.questions.selectedColor?.fill === '#FFF7AE'
      ? 'color: #363940;'
      : this.generalData.questions.selectedColor?.fill === '#A4BDFF'
      ? 'color: #1B0570;'
      : 'color: #fff;'
  }
  text-align: center;
  min-height: 40px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  align-self: stretch;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.25) inset,
    -4px -4px 8px 0px rgba(255, 255, 255, 0.25) inset;
}
.dimension:hover {
  background-color: ${
    this.generalData.questions?.selectedColor?.path || '#774DED'
  };
}
.contour {
  border: 2px solid ${
    this.generalData.questions?.selectedColor?.fill || '#5F2EEA'
  };
  background-color: transparent;
  padding: 4px var(--Box-Margem-vertical, 24px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 8px;
  min-height: 40px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
      ${
        (this.generalData.questions?.alternativesSelectedBackgroundColor
          ?.background || '#000000') === '#000000'
          ? 'color: #FFFFFF;'
          : 'color: #363940;'
      }
}

.contour:hover {
  border-color: ${this.generalData.questions?.selectedColor?.path || '#774DED'};
}

.questionText{
 color: ${this.generalData.questions.questionTextColor?.color || '#FFF'};
 text-align: center;
 font-size: 16px;
 font-style: normal;
 font-weight: 700;
 line-height: normal;
 word-wrap: break-word;
    ${
      this.generalData.questions.layout === 1
        ? 'max-width: 200px;'
        : 'max-width: 100%;'
    }
  white-space: normal; /
}

                      .answers a{
                        font-size: 1.2rem;
                        text-decoration: none;
                        color: ${this.generalData.questions.fontColor.color};
                        background-color: rgba(0,0,0,0.8);
                        border-radius: 10px;
                        padding: 12px 15px;
                        border: 1px solid ${
                          this.generalData.questions.fontColor.color
                        };
                        margin-top: 10px;
                        cursor: pointer;
                      }
                      #skip-button{
                        position: absolute;
                        z-index: 100;
                        ${
                          this.generalData.questions.layout === 0 &&
                          this.generalData.questions.horizontalLayout === 0
                            ? 'bottom: 95px; left: 15px;'
                            : ''
                        }
                        ${
                          this.generalData.questions.layout === 0 &&
                          this.generalData.questions.horizontalLayout === 1
                            ? 'top: 15px; left: 15px;'
                            : ''
                        }
                        ${
                          this.generalData.questions.layout === 1 &&
                          this.generalData.questions.verticalLayout === 0
                            ? 'bottom: 70px; right: 15px;'
                            : ''
                        }
                        ${
                          this.generalData.questions.layout === 1 &&
                          this.generalData.questions.verticalLayout === 1
                            ? 'bottom: 70px; left: 15px;'
                            : ''
                        }

                        background-color: #EDEEF1;
                        color: #3F404C;
                        padding: 12px 22px;
                        font-size: 14px;
                        border: none;
                        border-radius: 8px;
                        font-weight: 600;
                        cursor: pointer;
                        outline: none;
                      }
                      @media (max-width: 550px){
                        #container2 {
                          ${
                            this.generalData.questions.layout === 1
                              ? ''
                              : 'height: 60px;'
                          }
                        }
                         #skip-button{
                         bottom: 70px;
                         ${
                           this.generalData.questions.verticalLayout === 0
                             ? 'right: 20px; left: auto'
                             : 'left: 20px; right: auto;'
                         }
                         }
                         #container {
                         bottom: 60px;                   
                          ${
                            this.generalData.questions.layout === 0
                              ? ''
                              : 'min-height: 40px;'
                          } 
                         }    
                        .dimension {
                        min-height: 30px;
                        padding: 6px 12px;
                        }
                        .answers {
                         gap: 12px;
                        }
                        .default {
                        min-height: 30px;
                        padding: 6px 12px;
                        }
                        .contour {
                        min-height: 30px;
                        padding: 6px 12px;
                        }
                        .questionText {
                         font-size: 10px;
                        }  
                        .progress-container {
                          bottom: 55px;
                        }
                        h2 {
                          font-size: 10px;
                        }
                        .answers button{
                          font-size: 9px;
                          margin-top: -5px;
                        }
                      }

                    </style>
                    <div id="video-container" class="click-area">
                    <div class="side-section">
                    <div id="container" class="top-slide-in">
                    </div>
                    <div                           ${
                      this.generalData.questions.layout === 1
                        ? 'class="slide-in"'
                        : ''
                    }; style="background: ${this.hexToRgba(
          this.generalData.background.color.color,
          this.generalData.background.color.opacity
        )};; display: flex; justify-content: center;" id="progressContainer" >
                    </div>
                    <div id="container2" class="slide-in">
                    </div>
                     </div>
                     </div>
                    ${
                      this.generalData.questions.allowSkip
                        ? `<button id="skip-button" onclick="skipQuestion()">${this.generalData.questions.skipButtonText}</button>`
                        : ''
                    }
                    <script> 
                      // Configurações vindas do Vue
                      const pauseVideoEnd = ${JSON.stringify(pauseVideoEnd)};
                      const selectedExitAnimation = ${JSON.stringify(
                        selectedExitAnimation
                      )};
                      function shouldAnimateExit() {
                        return selectedExitAnimation !== 'nothing';
                      }

                      // Função unificada para aplicar animações de saída
                      function applyExitAnimations() {
                        if (exitAnimationsApplied) return; // Evita animações duplicadas
                        exitAnimationsApplied = true;
                        const container = document.getElementById('container');
                        const container2 = document.getElementById('container2');
                        const progressBar = document.getElementById('progressContainer');
                        const skipButton = document.getElementById('skip-button');
                        if (container) container.classList.add('slide-out');
                        if (container2) container2.classList.add('bottom-slide-out');
                        if (progressBar) progressBar.classList.add('slide-out');
                        if (skipButton) skipButton.style.opacity = '0';
                      }

                      // Função unificada para remover o CTA após animação
                      function removeCtaAfterAnimation() {
                        setTimeout(() => {
                          window.parent.postMessage({
                            type: 'remove_cta',
                            parameter: '${this.$route.params.quizId}',
                          }, '*');
                        }, 500);
                      }

                      // Função para remover o CTA, com ou sem animação
                      function removeCtaWithOptionalAnimation() {
                        if (shouldAnimateExit()) {
                          applyExitAnimations();
                          removeCtaAfterAnimation();
                        } else {
                          window.parent.postMessage({
                            type: 'remove_cta',
                            parameter: '${this.$route.params.quizId}'
                          }, '*');
                        }
                      }

                      // Listener para remoção externa
                      window.addEventListener('message', function(event) {
                        if (event.data.type === 'remove_cta' && event.data.parameter === '${
                          this.$route.params.quizId
                        }') {
                          removeCtaWithOptionalAnimation();
                        }
                      });

                      document.querySelector('.click-area').addEventListener('click', function(event) {
    if (event.target === this) {
    }
  });

                      const quizData = ${JSON.stringify(quizQuestions)};
                      let currentQuestionIndex = 0;
                      let exitAnimationsApplied = false; // Flag para evitar animações duplicadas
                      function onClickAnswer(questionIndex, answerIndex){
                        const question = quizData[questionIndex];
                        const answer = question.answers[answerIndex];
                        
                        if(answer.action.type === 'open_link'){
                          removeCtaWithOptionalAnimation();
                          return;
                        }
                        
                        if(answer.action.type === 'redirect_video'){
                          if (shouldAnimateExit()) {
                            applyExitAnimations();
                            setTimeout(() => {
                              window.parent.postMessage({
                                type: 'redirect_video',
                                parameter: {
                                  videoId: answer.action.videoExternalId
                                }
                              }, '*');
                            }, 500);
                          } else {
                            window.parent.postMessage({
                              type: 'redirect_video',
                              parameter: {
                                videoId: answer.action.videoExternalId
                              }
                            }, '*');
                          }
                          return;
                        }
                        
                        const isLastQuestion = currentQuestionIndex === quizData.length - 1;
                        
                        if (answer.action.type === 'redirect_question') {
                          const targetQuestionIndex = answer.action.nextQuestion;
                          const nextQuestion = quizData[targetQuestionIndex];
                          renderQuestion(nextQuestion);
                          return;
                        }

                        if(isLastQuestion && answer.action.type !== 'redirect_question'){
                          removeCtaWithOptionalAnimation();
                        }
                      }
                      
                      function skipQuestion(){
                        removeCtaWithOptionalAnimation();
                      }
                        function timeToSeconds(time) {
                         const [minutes, seconds] = time.split(':').map(Number);
                         return minutes * 60 + seconds;
                      }
                      function renderQuestion(question){
                        const existentQuestion = document.querySelector('.question');
                        if(existentQuestion){
                          existentQuestion.remove();
                        }
                        const questionIndex = quizData.indexOf(question);
                        currentQuestionIndex = questionIndex;
                        exitAnimationsApplied = false; // Reset da flag para nova pergunta
                        const isLastQuestion = questionIndex === quizData.length - 1;
                        const currentTime = window.parent.player.media.plyr.thumbnails.lastTime;
                         let timeLeft = ${this.generalData.duration};
                         const totalTime = ${this.generalData.duration};
                         const startTime = timeToSeconds('${
                           this.generalData.startTime
                         }');
                         const endTime = timeToSeconds('${
                           this.generalData.endTime
                         }');

function updateProgressBar() {
  const currentTime = window.parent.player.media.plyr.thumbnails.lastTime;

  if (currentTime >= startTime && currentTime <= endTime) {
    const elapsedTime = currentTime - startTime;
    const totalTime = endTime - startTime;
    const progressPercentage = (elapsedTime / totalTime);
    const progressBar = document.querySelector('.progress-bar');
    if (progressBar) {
      progressBar.style.transform = 'scaleX(' + progressPercentage + ')';
    }
  }

  // Detecta quando o CTA deve sair automaticamente (tempo acabou)
  if (currentTime > endTime) {
    if (!pauseVideoEnd) {
      removeCtaWithOptionalAnimation();
    }
    // Se pauseVideoEnd for true, o CTA permanece na tela
    return; // Para a animação do progress bar
  }

  requestAnimationFrame(updateProgressBar);
}

requestAnimationFrame(updateProgressBar);                    
                        const windowWidth = window.innerWidth;
                        const answersHtml = \`
                        <div class="question">
                         <span class="questionText"> \${question.question} </span>
                          </div>
                        \`;
                        const progressBarContainer = \`
                             <div class="progress-container">
                             <div class="progress-bar"></div>
                        </div>
                        \`;
                        const questionsHtml = \`
                        <div class="question">
                          <div class="answers">
                            \${question.answers.map((answer, answerIndex)=>answer.action.type==='open_link'?\`
                            <button onclick="window.open('\${answer.action.link}', '_blank')" class="${
                              this.generalData.questions.selectedButtonModel
                            }" onclick="onClickAnswer(\${questionIndex}, \${answerIndex})" target="_blank" onmouseover="this.querySelector('path').style.fill='url(#paint0_linear_hover_6400_33798)'" onmouseout="this.querySelector('path').style.fill='url(#paint0_linear_6400_33798)'">
                            \${answer.text}
                              <div> ${
                                this.generalData.questions
                                  .selectedButtonModel === 'losangle'
                                  ? `
                               <svg style="padding-top: \${windowWidth < 550 ? '5px' : '12px'}" xmlns="http://www.w3.org/2000/svg" width="\${windowWidth < 550 ? 100 : 153}" height="5" viewBox="0 0 153 5" fill="none">
                                 <path d="M153 2.5L76.5 0.5L0 2.5L76.5 4.5L153 2.5Z" fill="url(#paint0_linear_6400_33798)"/>
                                  <defs>
                                   <linearGradient id="paint0_linear_6400_33798" x1="-0.187961" y1="0.5" x2="152.838" y2="2.76145" gradientUnits="userSpaceOnUse">
                                     <stop stop-color="${
                                       this.generalData.questions?.selectedColor
                                         ?.fill
                                     }"/>
                                     <stop offset="1" stop-color="${this.lightenColor(
                                       this.generalData.questions?.selectedColor
                                         ?.fill || '#5F2EEA',
                                       50
                                     )}"/>
                                   </linearGradient>
                                   <linearGradient id="paint0_linear_hover_6400_33798" x1="-0.187961" y1="0.5" x2="152.838" y2="2.76145" gradientUnits="userSpaceOnUse">
                                     <stop stop-color="${
                                       this.generalData.questions?.selectedColor
                                         ?.path
                                     }"/>
                                     <stop offset="1" stop-color="${this.lightenColor(
                                       this.generalData.questions?.selectedColor
                                         ?.path || '#774DED',
                                       50
                                     )}"/>
                                   </linearGradient>
                                  </defs>
                                </svg>`
                                  : ''
                              }
                               </div>
                            </button>
                            \`:\`
                            <button class="${
                              this.generalData.questions.selectedButtonModel
                            }" onclick="onClickAnswer(\${questionIndex}, \${answerIndex})" style="${
          this.generalData.questions.layout === 1
            ? 'max-width: 200px; '
            : 'max-width: 100%;'
        } white-space: normal; word-wrap: break-word;" onmouseover="this.querySelector('path').style.fill='url(#paint0_linear_hover_6400_33798)'" onmouseout="this.querySelector('path').style.fill='url(#paint0_linear_6400_33798)'">\${answer.text}
                              <div> ${
                                this.generalData.questions
                                  .selectedButtonModel === 'losangle'
                                  ? `
                               <svg style="padding-top: \${windowWidth < 550 ? '5px' : '12px'}" xmlns="http://www.w3.org/2000/svg" width="\${windowWidth < 550 ? 100 : 153}" height="5" viewBox="0 0 153 5" fill="none">
                                <path d="M153 2.5L76.5 0.5L0 2.5L76.5 4.5L153 2.5Z" fill="url(#paint0_linear_6400_33798)"/>
                                 <defs>
                                  <linearGradient id="paint0_linear_6400_33798" x1="-0.187961" y1="0.5" x2="152.838" y2="2.76145" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="${
                                      this.generalData.questions?.selectedColor
                                        ?.fill
                                    }"/>
                                    <stop offset="1" stop-color="${this.lightenColor(
                                      this.generalData.questions?.selectedColor
                                        ?.fill || '#5F2EEA',
                                      50
                                    )}"/>
                                  </linearGradient>
                                  <linearGradient id="paint0_linear_hover_6400_33798" x1="-0.187961" y1="0.5" x2="152.838" y2="2.76145" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="${
                                      this.generalData.questions?.selectedColor
                                        ?.path
                                    }"/>
                                    <stop offset="1" stop-color="${this.lightenColor(
                                      this.generalData.questions?.selectedColor
                                        ?.path || '#774DED',
                                      50
                                    )}"/>
                                  </linearGradient>
                                 </defs>
                               </svg>`
                                  : ''
                              }
                              </div>
                            </button>
                            \`).join('')}
                          </div>
                        \`;
                          document.getElementById('container').innerHTML = answersHtml;
                          document.getElementById('container2').innerHTML = questionsHtml;
                          if (${this.generalData.questions.hasTimeBar}) {
                          document.getElementById('progressContainer').innerHTML = progressBarContainer;
                          const progressBar = document.querySelector('.progress-bar');
                          }
                          const containerElement = document.getElementById('container');
                          if (question.question.length === 0 && ${
                            this.generalData.questions.layout
                          } === 0) {
                          containerElement.style.removeProperty('display');
                          if (container) {
                            containerElement.style.display = 'none';
                          }
                        } else {
                          containerElement.style.display = 'flex';
                        }
                      }
                      renderQuestion(quizData[0]);


                    </scr` +
        `ipt>
                  `
      return quizScript
    },
    handleUpdateCurrentTime() {
      this.generalData.startTime = this.timelineItem.data.metadata.startTime
      this.generalData.endTime = this.timelineItem.data.metadata.endTime
      this.generalData.duration = this.timelineItem.data.duration
    },

    handleDataChange() {
      if (this.isInitializing) return

      const timelineItem = this.timelineItem
      if (!timelineItem) return

      const startTimeInSeconds = this.elementTimes.startTime
      const duration = this.elementTimes.duration

      // If start time is 00:00, treat it as 00:01 internally for player registration
      const effectiveStartTime =
        startTimeInSeconds === 0 ? 1 : startTimeInSeconds

      const newData = {
        ...timelineItem.data,
        metadata: {
          ...timelineItem.data.metadata,
          questions: this.questions,
          generalData: this.generalData,
          startTime: this.elementTimes.startTimeStr,
          endTime: this.elementTimes.endTimeStr,
          ctaType: 'quiz',
        },
        script: this.generatedScript,
        time: effectiveStartTime,
        duration: duration,
        maxZIndex: true,
        pauseVideo: this.generalData.questions.pauseVideo,
        pauseVideoEnd: this.generalData.questions.pauseVideoEnd,
        barColor: this.generalData.questions.fontColor.color,
        hasTimeBar: this.generalData.questions.hasTimeBar,
        alternativesSelectedBackgroundColor:
          this.generalData.questions.alternativesSelectedBackgroundColor,
        selectedButtonModel: this.generalData.questions.selectedButtonModel,
        buttonColor: this.generalData.questions.selectedColor,
        allowSkip: this.generalData.questions.allowSkip,
      }

      // Special handling for 00:00 start time
      if (startTimeInSeconds === 0) {
        newData.metadata.initializationDelay = true
      }

      const timelineItems = [...this.timelineItems]
      const itemIndex = timelineItems.findIndex(
        (item) => item.data?.id === timelineItem.data.id
      )
      if (itemIndex !== -1) {
        timelineItems[itemIndex].data = newData
        this.UPDATE_VIDEO_TIMELINE_ITEMS(timelineItems)
      }

      this.$root.$emit('reloadPlayerCtas')
    },
    handleQuestionsValidation(isValid) {
      this.isQuestionsValid = isValid
    },
    async getVideo(videoId) {
      try {
        const ret = await videosApi.getAVideo(videoId)
        return ret.data
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // Se a API retornar 404, mantemos o status UPLOADING
          return { status: 'UPLOADING' }
        }
        // Se for outro erro, retornamos null
        return null
      }
    },
  },
  mounted() {
    this.$emit('showFooter', true)
    this.$root.$on('handleDeleteQuizCta', () => {
      this.handleDelete()
    })
    this.$root.$on('timelineDrag', (isDragging) => {
      this.isTimelineDragging = isDragging
    })

    this.$root.$on('video-upload-started', () => {
      // Sempre mostra o loading quando um upload começar
      this.questions = this.questions.map((question) => {
        const answers = question.answers.map((answer) => {
          if (answer.action === 'redirect_video' && !answer.redirectVideoId) {
            return { ...answer, status: 'UPLOADING' }
          }
          return answer
        })
        return { ...question, answers }
      })
    })

    this.$root.$on('video-upload-completed', async (videoId) => {
      // Quando o upload completar, tentamos buscar o vídeo
      const video = await this.getVideo(videoId)
      if (video) {
        this.questions = this.questions.map((question) => {
          const answers = question.answers.map((answer) => {
            if (answer.action === 'redirect_video' && !answer.redirectVideoId) {
              return { ...answer, redirectVideoId: videoId }
            }
            return answer
          })
          return { ...question, answers }
        })
      }
    })

    this.$root.$on('update:pauseVideo', (pauseVideo) => {
      this.generalData.questions.pauseVideo = pauseVideo
    })

    this.$root.$on('update:hasTimeBar', (hasTimeBar) => {
      this.generalData.questions.hasTimeBar = hasTimeBar
    })

    this.$root.$on('update:selectedButtonModel', (selectedButtonModel) => {
      this.generalData.questions.selectedButtonModel = selectedButtonModel
    })

    this.$root.$on('update:selectedColor', (selectedColor) => {
      this.generalData.questions.selectedColor = selectedColor
    })

    this.$root.$on('update:pauseVideoEnd', (pauseVideoEnd) => {
      this.generalData.questions.pauseVideoEnd = pauseVideoEnd
    })

    this.$root.$on('update:skipText', (skipButtonText) => {
      this.generalData.questions.skipButtonText = skipButtonText
    })
    this.$root.$on('update:allowSkip', (allowSkip) => {
      this.generalData.questions.allowSkip = allowSkip
    })
    this.$root.$on('update:layout', (layout) => {
      this.generalData.questions.layout = layout
    })
    this.$root.$on('update:horizontalLayout', (horizontalLayout) => {
      this.generalData.questions.horizontalLayout = horizontalLayout
    })
    this.$root.$on('update:verticalLayout', (verticalLayout) => {
      this.generalData.questions.verticalLayout = verticalLayout
    })

    //update:fontColor
    this.$root.$on('update:fontColor', (fontColor) => {
      this.generalData.questions.fontColor = fontColor
    })

    //update:questionTextColor
    this.$root.$on('update:questionTextColor', (questionTextColor) => {
      this.generalData.questions.questionTextColor = questionTextColor
    })

    this.$root.$on('update:enterAnimation', (enterAnimation) => {
      this.generalData.questions.selectedEnterAnimation = enterAnimation
    })

    this.$root.$on('update:exitAnimation', (exitAnimation) => {
      this.generalData.questions.selectedExitAnimation = exitAnimation
    })

    this.$root.$on(
      'update:alternativesSelectedBackgroundColor',
      (alternativesSelectedBackgroundColor) => {
        this.generalData.questions.alternativesSelectedBackgroundColor =
          alternativesSelectedBackgroundColor
      }
    )
    this.$root.$on('updatePlayerQuizCta', async (action) => {
      this.loading = true
      this.UPDATE_LOADING_SAVE(true)
      await this.handleSave()
      this.UPDATE_LOADING_SAVE(false)
      this.loading = false
      this.$root.$emit(action, true)
      this.$root.$emit('closeDiscardChangesModal')
    })
    this.loadInitialData()
  },
  beforeDestroy() {
    this.$root.$off('handleDeleteQuizCta')
    this.$root.$off('updatePlayerQuizCta')
    this.$root.$off('timelineDrag')
    this.$root.$off('video-upload-started')
    this.$root.$off('video-upload-completed')
  },
  computed: {
    ...mapState({
      video: (state) => state.video.video,
      timelineItems: (state) => state.dashboard.timelineItems,
    }),

    locale() {
      return this.$i18next.resolvedLanguage
    },

    leadArticle() {
      if (this.locale === 'en') {
        return 'https://help.pandavideo.com/en-us/article/video-funnel-1k1xo/'
      }
      if (this.locale === 'es') {
        return 'https://help.pandavideo.com/es/article/funnel-de-videos-bn0awo/'
      }
      return 'https://help.pandavideo.com/pt-br/article/funil-de-videos-yw6y69/'
    },

    timelineItem() {
      return this.timelineItems.find(
        (item) => item.data.id === this.$route.params.quizId
      )
    },
    elementTimes() {
      const timelineInfoBarItem = this.timelineItem

      const startTime = timelineInfoBarItem.data.metadata.startTime // string format mm:ss
      const startTimeInSeconds =
        parseInt(startTime.split(':')[0]) * 60 +
        parseInt(startTime.split(':')[1])

      const endTime = timelineInfoBarItem.data.metadata.endTime // string format mm:ss
      const endTimeInSeconds =
        parseInt(endTime.split(':')[0]) * 60 + parseInt(endTime.split(':')[1])

      const duration = endTimeInSeconds - startTimeInSeconds
      return {
        startTime: startTimeInSeconds,
        duration,
        startTimeStr: startTime,
        endTimeStr: endTime,
      }
    },
    generatedScript() {
      return this.generateScriptFromQuestions()
    },
    currentVideoFolderId() {
      return this.video?.folder_id || null
    },
    withoutChanges() {
      // Evitar comparação durante inicialização
      if (this.isInitializing || !this.generalData.id) {
        return true
      }

      return (
        _.isEqual(this.generalData, this.initialGeneralData) &&
        _.isEqual(this.questions, this.initialQuestions)
      )
    },
    canSave() {
      return this.isQuestionsValid && this.questions.length > 0
    },
    hasValidUrls() {
      return this.questions.every((question) =>
        question.answers.every((answer) => {
          if (answer.action !== 'open_link') return true
          if (!answer.link || answer.link.trim() === '') return false

          try {
            // Usar o construtor URL para validação mais robusta
            const url = new URL(answer.link)
            return url.protocol === 'http:' || url.protocol === 'https:'
          } catch (error) {
            return false
          }
        })
      )
    },
    canPublish() {
      // Para novos CTAs, permite publicar se tem pelo menos uma pergunta (requisito mínimo)
      if (!this.isExistentCta) {
        return (
          this.questions.length > 0 &&
          this.hasValidUrls &&
          this.isQuestionsValid
        )
      }

      // Para CTAs existentes, basta haver qualquer alteração (questions ou configs)
      const hasChanges = !this.withoutChanges
      const hasQuestions = this.questions.length > 0

      return (
        hasChanges && hasQuestions && this.hasValidUrls && this.isQuestionsValid
      )
    },
    canCancel() {
      // Para novos CTAs, não há mudanças para desfazer, então deve estar desabilitado
      if (!this.isExistentCta) {
        return false
      }
      // Para CTAs existentes, só habilita se houver mudanças
      return !this.withoutChanges
    },
  },
  watch: {
    '$route.path': {
      handler() {
        this.loadInitialData()
      },
    },
    'timelineItem.data.duration': {
      handler() {
        this.handleUpdateCurrentTime()
        // Evitar executar durante inicialização
        if (this.isInitializing || !this.generalData.id) {
          return
        }
        // Marcar que houve mudança quando a duração é alterada
        const timelineInfoItem = this.timelineItems.find(
          (item) => item.data.id === this.generalData.id
        )
        if (timelineInfoItem) {
          timelineInfoItem.hasChanges = true
          this.$root.$emit('reRenderTimelineItems')
        }
      },
    },
    'timelineItem.data.time': {
      handler() {
        this.handleUpdateCurrentTime()
        // Evitar executar durante inicialização
        if (this.isInitializing || !this.generalData.id) {
          return
        }
        // Marcar que houve mudança quando o tempo é alterado
        const timelineInfoItem = this.timelineItems.find(
          (item) => item.data.id === this.generalData.id
        )
        if (timelineInfoItem) {
          timelineInfoItem.hasChanges = true
          this.$root.$emit('reRenderTimelineItems')
        }
      },
    },
    generalData: {
      handler() {
        // this.updateSaveArray()
        this.handleDataChange()
      },
      deep: true,
    },
    questions: {
      handler() {
        // this.updateSaveArray()
        this.handleDataChange()
        // Validate questions whenever they change
        if (this.questions.length > 0) {
          this.isQuestionsValid = this.validateAllQuestions()
        }
      },
      deep: true,
    },

    withoutChanges: {
      handler(val) {
        // Evitar executar durante inicialização
        if (this.isInitializing || !this.generalData.id) {
          return
        }

        const timelineInfoItem = this.timelineItems.find(
          (item) => item.data.id === this.generalData.id
        )
        if (timelineInfoItem) {
          timelineInfoItem.hasChanges = !val
          this.$root.$emit('reRenderTimelineItems')
        }
      },
      immediate: true,
    },
    '$route.params.quizId': {
      handler() {
        if (this.$route.params.quizId) {
          this.loadInitialData()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.backIcon {
  margin-right: 8px;
}

.grid__control {
  .menu__color {
    &:hover {
      background-color: varFigma(neutral-99);
    }
  }
}

.body-bold-medium {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  color: varFigma(neutral-20-dark);
}

.body-regular-smaller {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
}

.neutral-40-light--text {
  color: varFigma(neutral-40-light) !important;
}

.playr-tabs {
  margin-top: $spacing-05;
  &::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }
    .v-slide-group__next {
      display: none !important;
    }
    .v-slide-group__content {
      flex: 1 1 auto !important;
    }
  }
  &.v-tabs {
    padding: 0;
    &::v-deep {
      .v-tabs-bar {
        .v-tab {
          font-size: 12px;
          height: 24px;
          text-transform: initial;
          letter-spacing: 0px;
          border-bottom: 2px solid transparent;
          padding: 0;
          min-width: auto;
          margin-right: $spacing-05;
          white-space: nowrap;
          justify-content: start;
          max-width: fit-content;
          margin-left: 0 !important;

          &--active {
            color: varFigma(brand-50);
            border-bottom: 2px solid varFigma(brand-50);

            &:hover {
              color: varFigma(brand-40-dark);
            }
          }

          &:not([class*='active']) {
            color: var(--v-neutral-lighten1);

            &:hover {
              color: varFigma(neutral-30-base);
              border-bottom: 2px solid varFigma(neutral-80-lighter);
            }
          }
        }
        &.v-tabs-bar--is-mobile {
          .v-tab {
            font-size: 12px;
          }
        }
      }
      & .v-tab:hover::before,
      .v-tab::before {
        opacity: 0 !important;
      }
      & .v-tab:focus::before {
        opacity: 0 !important;
      }
    }

    &::v-deep {
      &.theme--dark {
        > .v-tabs-bar {
          .v-tab {
            &--active {
              color: var(--v-brand-lighten1);
            }
          }
        }
      }

      .v-tabs-slider-wrapper {
        display: none !important;
      }
    }
  }
}
</style>
